import { useTranslation } from '@shared/config/i18n'
import { useMemo } from 'react'

import { Chip, HStack } from '@podo-app/design-system-temp'

import type { LangItem } from '../../api/subscribe-v2.api'

type Props = {
  selectedLanguage: string
  handleChangeLanguage: (language: string) => void
  langList: LangItem[]
  queryLangType?: string | null
}

// 노출 순서: 일본어 → 영어 → 영어&일본어 (그 외 언어는 뒤에 원본 순서대로)
const LANG_TYPE_ORDER = ['JP', 'EN', 'ENJP']

const getLangOrder = (langType: string) => {
  const index = LANG_TYPE_ORDER.indexOf(langType)
  return index === -1 ? LANG_TYPE_ORDER.length : index
}

const SubscribeTicketLanguageChipV3 = ({ selectedLanguage, handleChangeLanguage, langList, queryLangType }: Props) => {
  const t = useTranslation()
  const filteredLangList = useMemo(() => {
    const filtered = !queryLangType
      ? langList
      : langList.filter((lang) => {
          if (lang.langType === 'ENJP') {
            return true
          }
          if (queryLangType === 'JP' && lang.langType === 'EN') {
            return false
          }
          if (queryLangType === 'EN' && lang.langType === 'JP') {
            return false
          }
          return true
        })

    return [...filtered].sort((a, b) => getLangOrder(a.langType) - getLangOrder(b.langType))
  }, [langList, queryLangType])

  const getLanguageLabel = (lang: LangItem) => {
    if (lang.langType === 'EN') {
      return t('subscribeList.chip.languageEn')
    }
    if (lang.langType === 'JP') {
      return t('subscribeList.chip.languageJa')
    }
    if (lang.langType === 'ENJP') {
      return t('subscribeList.chip.languageEnJa')
    }
    return lang.display
  }

  return (
    <HStack className="gap-2">
      {filteredLangList.map((lang) => (
        <Chip
          key={lang.langType}
          className="flex-1"
          selected={selectedLanguage === lang.langType}
          onClick={() => handleChangeLanguage(lang.langType)}
          data-testid={`chip-lang-${lang.langType.toLowerCase()}`}
        >
          {getLanguageLabel(lang)}
        </Chip>
      ))}
    </HStack>
  )
}

export default SubscribeTicketLanguageChipV3
